export default defineNuxtRouteMiddleware(async (to, from) => {
    console.log("check");
    if (import.meta.client) {
        const { $pwa } = useNuxtApp()

        // 如果偵測到新版本，直接觸發更新並中斷當前導航
        if ($pwa?.needRefresh.value) {
            await $pwa.updateServiceWorker(true)
            return // 停止渲染當前頁面
        }
    }
})
